import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  ISession,
  SessionStatusTypes,
  SessionContextTypes,
  SessionContextProviderInterface,
} from '../types/session.types';
import { getClientSideSession } from '../utils/session.utils';

export const SessionContext = createContext<SessionContextTypes>({
  session: null,
  status: 'loading',
});

export const SessionContextProvider: React.FC<
  SessionContextProviderInterface
> = ({ children, session }) => {
  const [sessionState, setSessionState] = useState<ISession | null>(session);
  const [status, setStatus] = useState<SessionStatusTypes>(
    session ? 'authenticated' : 'loading',
  );

  useEffect(() => {
    const initializeSession = async () => {
      try {
        const validSession = await getClientSideSession();

        if (validSession?.accessToken) {
          setSessionState(validSession);
          setStatus('authenticated');
        } else {
          setSessionState(null);
          setStatus('unauthenticated');
        }
      } catch {
        console.error('Error in initializeSession');
      }
    };

    initializeSession();
  }, [session]);

  return (
    <SessionContext.Provider
      value={{
        session: sessionState,
        status,
      }}
    >
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => useContext(SessionContext);
